import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Autocomplete, InputAdornment, IconButton } from "@mui/material";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import Button from "@mui/material/Button";
import { useParams, useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import ClearIcon from "@mui/icons-material/Clear";
import "./FranchiseeUpdateComponent.css";

const FranchiseeUpdateComponent = (props) => {
  const { cohortId } = useParams();
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [selectedCohortType, setSelectedCohortType] = useState(null);

  // Cohort type mapping
  const cohortTypeMapping = {
    "13": "PDF",
    "4": "FOCO(City)",
    "2": "FOFO(Franchise)",
    // Add more mappings as needed
  };

  // Create cohort type options from mapping
  const cohortTypeOptions = Object.entries(cohortTypeMapping).map(([id, name]) => ({
    id: id,
    name: name
  }));

  // Set selected cohort type when formDataFranchisee changes
  useEffect(() => {
    console.log("formDataFranchisee in component:", props.formDataFranchisee);
    if (props.formDataFranchisee?.cohortTypeId) {
      // Convert to string for comparison since mapping keys are strings
      const cohortTypeIdStr = String(props.formDataFranchisee.cohortTypeId);
      console.log("Looking for cohort type with ID:", cohortTypeIdStr);
      
      const matchingCohortType = cohortTypeOptions.find(
        option => option.id === cohortTypeIdStr
      );
      console.log("Matching cohort type found:", matchingCohortType);
      setSelectedCohortType(matchingCohortType || null);
    } else {
      setSelectedCohortType(null);
    }
  }, [props.formDataFranchisee?.cohortTypeId, props.formDataFranchisee?.type]);

  // Alternative: Also set based on type field if needed
  useEffect(() => {
    if (!selectedCohortType && props.formDataFranchisee?.type) {
      // Try to find by name if type field is available
      const matchingByType = cohortTypeOptions.find(
        option => option.name.toLowerCase() === props.formDataFranchisee.type.toLowerCase()
      );
      if (matchingByType) {
        setSelectedCohortType(matchingByType);
        // Also update the form data with the correct ID
        props.handleUpdateFranchisee({
          target: {
            name: "cohortTypeId",
            value: parseInt(matchingByType.id),
          },
        });
      }
    }
  }, [props.formDataFranchisee?.type]);

  // Filter warehouse list based on search input
  const filteredWarehouses = props.warehouseList
    ? props.warehouseList.filter(warehouse =>
      warehouse.name?.toLowerCase().includes(searchInput.toLowerCase()) ||
      warehouse.id?.toString().includes(searchInput)
    )
    : [];

  // Get the current warehouse object based on the warehouse ID in form data
  const selectedWarehouse = props.warehouseList?.find(
    wh => wh.id === props.formDataFranchisee?.warehouseId
  ) || null;

  const goback = () => {
    navigate(-1);
  };

  return (
    <div className="franchisee-main">
      <Sidebar />

      <div className="franchisee-content">
        <div className="franchisee-header">
          <h2>
            <img
              onClick={goback}
              className="back-arrow"
              src={leftArrow}
              alt="Back"
            />{" "}
            Edit Franchisee
          </h2>
        </div>

        <div className="franchisee-form-container">
          <Box className="franchisee-form-box">
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={props.formDataFranchisee?.name || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
            />
            
            <TextField
              fullWidth
              label="Description"
              name="description"
              value={props.formDataFranchisee?.description || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
            />
            
            {/* Cohort Type Autocomplete */}
            <Autocomplete
              style={{ width: "500px" }}
              options={cohortTypeOptions}
              getOptionLabel={(option) => {
                if (!option) return "";
                return `${option.name}${option.id ? ` (ID: ${option.id})` : ''}`;
              }}
              value={selectedCohortType}
              onChange={(event, newValue) => {
                setSelectedCohortType(newValue);
                if (newValue) {
                  props.handleUpdateFranchisee({
                    target: {
                      name: "cohortTypeId",
                      value: parseInt(newValue.id),
                    },
                  });
                } else {
                  props.handleUpdateFranchisee({
                    target: {
                      name: "cohortTypeId",
                      value: "",
                    },
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return option?.id === value?.id;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="mui-text-field"
                  label="Cohort Type"
                  placeholder="Select cohort type"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {selectedCohortType && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedCohortType(null);
                                props.handleUpdateFranchisee({
                                  target: {
                                    name: "cohortTypeId",
                                    value: "",
                                  },
                                });
                              }}
                            >
                              {/* <ClearIcon /> */}
                            </IconButton>
                          </InputAdornment>
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <div style={{ fontWeight: 600 }}>{option.name}</div>
                  <div style={{ fontSize: "12px", color: "#666", marginLeft: "8px" }}>
                    ID: {option.id}
                  </div>
                </li>
              )}
              noOptionsText="No cohort types found"
            />

            {/* Warehouse Dropdown with Search */}
            <Autocomplete
              style={{ width: "500px" }}
              options={filteredWarehouses}
              getOptionLabel={(option) => option && option.name ? `${option.name} (ID: ${option.id})` : ""}
              value={selectedWarehouse}
              onChange={(event, newValue) => {
                if (newValue) {
                  props.handleUpdateFranchisee({
                    target: {
                      name: "warehouseId",
                      value: newValue.id
                    }
                  });
                } else {
                  props.handleUpdateFranchisee({
                    target: {
                      name: "warehouseId",
                      value: ""
                    }
                  });
                }
              }}
              onInputChange={(event, newInputValue) => {
                setSearchInput(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="mui-text-field"
                  label="Select Warehouse"
                  placeholder="Search by name or ID"
                  fullWidth
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <div style={{ fontWeight: 600, marginRight: "10px" }}>{option.name}</div>
                  <div style={{ fontSize: "12px", color: "#666" }}>ID: {option.id}</div>
                </li>
              )}
              noOptionsText="No warehouses found"
            />

            <TextField
              fullWidth
              label="Cohort ID"
              name="cohortId"
              value={props.formDataFranchisee?.cohortId || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
              InputLabelProps={{ shrink: true }}
              disabled
            />

            <TextField
              fullWidth
              label="Owner ID"
              name="ownerId"
              type="number"
              value={props.formDataFranchisee?.ownerId || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
            />
          </Box>

          <Box className="franchisee-button-group">
            <Button variant="outlined" onClick={goback}>
              Back
            </Button>
            <Button 
              variant="contained" 
              onClick={props.handleApicallToUpdate}
              disabled={props.loading}
            >
              Save
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default FranchiseeUpdateComponent;